import { FormattedNumber } from '@cmg/i18n';
import React from 'react';

import { FilingType } from '../../../../../../../graphql';
import {
  OfferingDetails_PublishedOffering_FilingsFragment,
  OfferingDetails_PublishedOffering_FollowOnPricingFragment,
  OfferingDetails_PublishedOfferingFragment,
} from '../../../../../../offering-side-panel/offering-details/graphql/__generated__';
import { KeyValuePair } from '../../../../KeyValuePair';

type FollowOnPairsProps = {
  latestFilling?: OfferingDetails_PublishedOffering_FilingsFragment;
  followOnPricing?: OfferingDetails_PublishedOffering_FollowOnPricingFragment | null;
  pricingCurrencyCode: OfferingDetails_PublishedOfferingFragment['pricingCurrencyCode'];
};

export function FollowOnPairs({
  followOnPricing,
  latestFilling,
  pricingCurrencyCode,
}: Readonly<FollowOnPairsProps>) {
  if (latestFilling?.filingType === FilingType.Final) {
    return (
      <React.Fragment>
        <KeyValuePair
          label="Offering Price"
          value={
            <FormattedNumber
              value={latestFilling?.offerPrice}
              format="currency"
              currency={pricingCurrencyCode}
            />
          }
        />
        <ReOfferLowHighPair
          followOnPricing={followOnPricing}
          pricingCurrencyCode={pricingCurrencyCode}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <KeyValuePair
        label="LT Before Launch"
        value={
          <FormattedNumber
            value={followOnPricing?.lastTradeBeforeLaunch}
            format="currency"
            currency={pricingCurrencyCode}
          />
        }
      />
      <KeyValuePair
        label="LT Before Offer"
        value={
          <FormattedNumber
            value={followOnPricing?.lastTradeBeforeOffer}
            format="currency"
            currency={pricingCurrencyCode}
          />
        }
      />
      <ReOfferLowHighPair
        followOnPricing={followOnPricing}
        pricingCurrencyCode={pricingCurrencyCode}
      />
    </React.Fragment>
  );
}

type ReOfferLowHighProps = {
  followOnPricing?: OfferingDetails_PublishedOffering_FollowOnPricingFragment | null;
  pricingCurrencyCode: OfferingDetails_PublishedOfferingFragment['pricingCurrencyCode'];
};

export function ReOfferLowHighPair({
  followOnPricing,
  pricingCurrencyCode,
}: Readonly<ReOfferLowHighProps>) {
  if (followOnPricing?.reOfferLow && followOnPricing?.reOfferHigh) {
    return (
      <KeyValuePair
        label="Re-Offer Low/High"
        value={
          <React.Fragment>
            <FormattedNumber
              value={followOnPricing.reOfferLow}
              format="currency"
              currency={pricingCurrencyCode}
              emptyValueLabel=""
            />
            –
            <FormattedNumber
              value={followOnPricing.reOfferHigh}
              format="currency"
              currency={pricingCurrencyCode}
              emptyValueLabel=""
            />
          </React.Fragment>
        }
      />
    );
  }
  return <KeyValuePair label="Re-Offer Low/High" value="-" />;
}
